import React, { Component } from "react";
import Page from "../../containers/page";
import xIcon from '../../assets/svg/x.svg';

import {
    Container,
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Table,
    Input,
    FormGroup,
    Label,
    Button,
} from "reactstrap";

import Isvg from "react-inlinesvg";

import { Player, Controls } from '@lottiefiles/react-lottie-player';

import FormBuilder from "../../components/forms/modalFormBuilder";
import { required } from "../../components/forms/validation";
import ErrorModal from '../../components/errorModal';
import InfoModal from '../../components/infoModal';
import ListBuilder from "../../components/listBuilder";
import DeleteModal from "../../components/deleteModal";
import {
    getSearchParams,
    generateSearchLink,
    generateSearchLinkMultiple,
} from "../../helpers/linkHelper";
import { API_ENDPOINT, DOMAINS, getAgeLimit } from "../../constants";
import { formValueSelector, change } from "redux-form"; // ES6
import { connect } from "react-redux";
import ClinicsFilter from "../../components/clinicsFilter";
import UsersFilter from "../../components/usersFilter";
import Image from "../../components/forms/fields/image";
import Zip from "../../components/forms/fields/zip";


import edit from "../../assets/svg/edit.svg";
import garabage from "../../assets/svg/garbage.svg";
import ehrIcon from "../../assets/svg/export-ehr.svg";
import attachInvoice from '../../assets/svg/attach.svg'

import addIcon from "../../assets/svg/add-icon.svg";
import webdocImage from "../../assets/images/webdoc.png";
import teleqImage from "../../assets/images/teleqLogo.png";
import sembleImage from "../../assets/images/semble.webp";
import labPortalenImage from '../../assets/images/Labportalen_logo.png';

import takeCareImage from '../../assets/images/take_care.webp';
import Search from "../../components/search";
import profileUser from "../../assets/images/user.png";
import notification from "../../assets/svg/notification.svg";
import Usage from "../../assets/svg/usage.svg";
import importIcon from '../../assets/svg/import.svg'

import exportIcon from "../../assets/svg/export.svg";
import Checkbox from '../../components/forms/fields/checkbox';
import MainClicGroupFilter from '../../components/mainClinicGroupsFilter';
import striptags from "striptags";

import downloadIcon from '../../assets/svg/download.svg';

import axios from 'axios'


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}

class ClinicGroupsDeletionComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,

        }
    }

    getClinicGroupsDeletion = () => {
        const clinicGroupsDeletionId = this.props.clinicGroupsDeletionId;
        if (!clinicGroupsDeletionId) return;
        const getLogApi = `${API_ENDPOINT}/data/clinic-groups/delete-data/get/${clinicGroupsDeletionId}`;
        const token = typeof localStorage !== "undefined" ? `Bearer ${localStorage.getItem("authToken")}` : null;

        fetch(getLogApi, {
            method: "GET",
            headers: {
                Authorization: token,
                "content-type": "application/json",
            },
        }).then((res) => res.json()).then((result) => {
            const clinicGroupsDeletion = result?.clinicGroupsDeletion;
            this.setState({ clinicGroupsDeletion }, () => {
                if (this.clinicGroupsDeletionInterval) clearInterval(this.clinicGroupsDeletionInterval);
                if (!this.state.clinicGroupsDeletion?.finished) {
                    this.clinicGroupsDeletionInterval = setInterval(() => {
                        this.getClinicGroupsDeletion();
                    }, 3000)
                }
            })
        })
    }

    setInitialData = () => {
        this.getClinicGroupsDeletion();
    }




    componentDidMount() {
        this.setInitialData();



    }
    componentDidUpdate(prevProps, prevState) {


    }
    componentWillUnmount() {
        if (this.clinicGroupsDeletionInterval) clearInterval(this.clinicGroupsDeletionInterval);
    }

    toggle = (callback = null) => {
        if (this.props.toggle) {
            this.props.toggle(callback);
        }

    }





    render() {
        const isOpen = this.props.clinicGroupsDeletionId ? true : false;

        const { clinicGroupsDeletion } = this.state || {};

        const startTime = clinicGroupsDeletion?.tsStart ? this.props.getStringDateTs(clinicGroupsDeletion.tsStart, this.props.dateFormat + ' HH:mm') : null;
        const finishedTime = clinicGroupsDeletion?.finishedTs ? this.props.getStringDateTs(clinicGroupsDeletion.finishedTs, this.props.dateFormat + ' HH:mm') : null;
        const userName = clinicGroupsDeletion?.user?.username;
        const isFinished = clinicGroupsDeletion?.finished;
        const isFailed = clinicGroupsDeletion?.failed;

        const logs = clinicGroupsDeletion?.log?.reverse() || [];
        const logsNotFinished = clinicGroupsDeletion?.log?.length && !clinicGroupsDeletion?.finished;
        return (
            <>

                <Modal isOpen={isOpen} centered size="lg">
                    <ModalHeader toggle={() => this.toggle()}
                        close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.toggle()}>&times;</button>}>
                        {'Delete log clinic group'.translate(this.props.lang)}
                    </ModalHeader>

                    <ModalBody>
                        <div className="clinic-group-export-modal-wrap">
                            <div className="clinic-group-exported-data-wrap">
                                {!clinicGroupsDeletion?._id ?
                                    <div className="no-exports">
                                        <p>{'No data yet'.translate(this.props.lang)}</p>
                                    </div>
                                    :
                                    <div className="clinic-group-exported-data">
                                        <div className="clinic-group-exported-data-item">
                                            <div className="clinic-group-exported-data-item-left">
                                                <div style={{ fontSize: 14 }}>{'Started by'.translate(this.props.lang)}: {userName} </div>
                                                <div style={{ fontSize: 14 }}>{startTime ? `Started at: ${startTime}` : null}</div>
                                                <div style={{ fontSize: 14, fontWeight: !isFinished ? 700 : 400 }}>{isFinished ? `Finished at: ${finishedTime}` : 'Delete in progress...'.translate(this.props.lang)}</div>
                                                {isFailed && <div style={{ fontSize: 14, color: 'red' }}>{'Delete failed'.translate(this.props.lang)}</div>}
                                            </div>

                                        </div>
                                        <div className="clinic-group-exported-data-logs" style={{ padding: 10 }}>
                                            {!logs?.length ?
                                                <div className="no-logs">
                                                    <p>{'No logs available'.translate(this.props.lang)}</p>
                                                </div>
                                                :
                                                <div className="clinic-group-export-log" style={{ maxHeight: '50vh', overflowY: 'auto' }}>
                                                    {
                                                        logsNotFinished ?
                                                            <div className="loader-wrap">
                                                                <Player
                                                                    autoplay={true}
                                                                    loop={true}
                                                                    renderer={'svg'}
                                                                    src="/lf30_editor_l5cxzdyf.json"
                                                                    style={{ height: "80px", width: "80px" }}
                                                                ></Player>
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                    {logs.map((logItem, index) => {
                                                        const error = logItem?.error;
                                                        const details = logItem?.details;
                                                        const logMessage = logItem?.message;
                                                        const duration = logItem?.duration;
                                                        let arr = [];
                                                        if (logItem?.items?.total) arr.push(`Total: ${logItem.items.total}`);
                                                        if (logItem?.items?.deleted) arr.push(`Deleted: ${logItem.items.deleted}`);
                                                        if (logItem?.items?.updated) arr.push(`Updated: ${logItem.items.updated}`);
                                                        const itemsCount = arr.length ? ` (${arr.join(', ')})` : '';


                                                        return (
                                                            <div key={index} className="clinic-group-export-log-item" style={{ border: '1px solid #ccc' }}>
                                                                <div style={{ fontWeight: 500, fontSize: 12 }}>{logMessage}{itemsCount}</div>
                                                                {
                                                                    duration ?
                                                                        <div style={{ fontSize: 12, color: '#aaa' }}>Duration: {duration ? `${duration}` : 'N/A'}</div>
                                                                        : null
                                                                }
                                                                {error && details && <div style={{ marginTop: 10, color: 'red', fontSize: 14 }}>Error: {details}</div>}
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>

                    </ModalBody>
                    <ModalFooter className="buttons-right-blue event-meetings-modal-footer-wrap ">
                        <Button style={{ minWidth: 100 }} color="primary" onClick={() => this.toggle()} >
                            {'Close'.translate(this.props.lang)}
                        </Button>
                    </ModalFooter>
                </Modal>





            </>


        )
    }
}

export default ClinicGroupsDeletionComponent;